var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangleNonRecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 7,
    viewBox: "0 0 20 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.542969,
    width: 20,
    height: 6,
    fill: "#D7D8DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleNonRecycle);
export default __webpack_public_path__ + "static/media/rectangle-non-recycle.e1bc3b9f0768c4864a481583c0411400.svg";
export { ForwardRef as ReactComponent };